import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { useIntl } from "react-intl";
import Layout from "../layout/index";
import { ROOT_API } from "../../api/config";
import "./style.scss";

// Public cancel-alerts page reached from an emailed link. The opaque token in the URL is the
// auth — no login needed. Confirming stops alerts for the address that email was about.
const Unsubscribe = () => {
  const intl = useIntl();
  const { token } = useParams();
  const [state, setState] = useState("loading"); // loading | ready | done | already | invalid | error
  const [address, setAddress] = useState(null);
  const [busy, setBusy] = useState(false);

  const t = (id, values) => intl.formatMessage({ id }, values);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await axios.get(`${ROOT_API}apis/unsubscribe/${token}`);
        const d = res?.data || {};
        if (!alive) return;
        if (!d.valid) {
          setState("invalid");
        } else {
          setAddress(d.address || null);
          setState(d.active ? "ready" : "already");
        }
      } catch (e) {
        if (alive) setState("error");
      }
    })();
    return () => {
      alive = false;
    };
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    try {
      const res = await axios.post(`${ROOT_API}apis/unsubscribe/${token}`);
      const d = res?.data || {};
      setState(d.valid ? "done" : "invalid");
    } catch (e) {
      setState("error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <div className="container">
        <div className="unsub">
          <h1 className="unsub__title">{t("unsub_title")}</h1>

          {state === "loading" ? (
            <p className="unsub__lead">{t("unsub_loading")}</p>
          ) : state === "invalid" ? (
            <p className="unsub__lead">{t("unsub_invalid")}</p>
          ) : state === "error" ? (
            <p className="unsub__lead">{t("unsub_error")}</p>
          ) : state === "done" || state === "already" ? (
            <>
              <p className="unsub__lead unsub__lead--ok">
                {t(state === "done" ? "unsub_done" : "unsub_already")}
              </p>
              <Link to="/" className="unsub__btn unsub__btn--ghost">
                {t("unsub_back")}
              </Link>
            </>
          ) : (
            <>
              <p className="unsub__lead">
                {address
                  ? t("unsub_explain", { address })
                  : t("unsub_explain_noaddr")}
              </p>
              <div className="unsub__actions">
                <button
                  type="button"
                  className="unsub__btn unsub__btn--danger"
                  onClick={confirm}
                  disabled={busy}
                >
                  {t("unsub_confirm")}
                </button>
                <Link to="/" className="unsub__btn unsub__btn--ghost">
                  {t("unsub_cancel")}
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Unsubscribe;
